<template>
    <div
        v-if="visible"
        class="flex flex-col md:flex-row bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 overflow-hidden relative col-span-12"
    >
        <div class="flex flex-col gap-4 py-6 px-6 md:px-8 flex-1 z-10">
            <div class="flex flex-col gap-2">
                <h2 class="text-xl md:text-2xl font-semibold text-slate-800 dark:text-slate-100">
                    Your wallet shows you may qualify for a 150K-point welcome
                    offer
                </h2>
                <p class="text-sm text-slate-500">
                    A premium travel card just relaunched its biggest welcome
                    bonus. Based on the data in your wallet, you appear
                    eligible.
                </p>
            </div>
            <div
                class="flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-4"
            >
                <a
                    :href="ctaUrl"
                    class="inline-flex items-center justify-center px-4 py-2.5 bg-10x-orange text-white text-sm font-medium rounded shadow-sm hover:bg-orange-600 transition-colors"
                >
                    See the offer
                </a>
                <button
                    type="button"
                    class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium text-slate-600 hover:text-slate-800 dark:text-slate-100 transition-colors"
                    @click="dismiss"
                >
                    Not interested
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import axios from 'axios';

const props = defineProps({
    eligible: { type: Boolean, default: false },
    dismissedAt: { type: String, default: null },
    campaignActive: { type: Boolean, default: false },
    ctaUrl: { type: String, required: true },
    dismissUrl: { type: String, required: true },
});

// Local override so the banner hides immediately on click without waiting
// for a server round-trip + page reload. The dismissal POST persists the
// state so the banner stays hidden on subsequent loads.
const isLocallyDismissed = ref(false);

const visible = computed(
    () =>
        props.eligible &&
        !props.dismissedAt &&
        !isLocallyDismissed.value &&
        props.campaignActive
);

// Fire-and-forget axios POST. Inertia's router.post can't handle the 204
// No Content response from the dismissal endpoint — it interprets it as
// an empty page and renders a blank state. See c1vb-modal for context.
function dismiss() {
    isLocallyDismissed.value = true;
    axios.post(props.dismissUrl).catch(() => {
        // Best-effort: if the POST fails, banner stays hidden this
        // session and reappears on next page load.
    });
}
</script>
